import React from 'react';

const PlusAlt = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="37"
    height="37"
    viewBox="0 0 37 37"
    fill="none"
  >
    <path
      d="M18.5021 2.4668V34.5335M2.46875 18.5001H34.5354"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PlusAlt;
